<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">

        <!-- Introduzione con Titolo, Descrizione e Divisorio -->
        <div class="introduzione">
          <h1>Procedure Aziendali</h1>
          <p>Qui troverai tutte le procedure aziendali aggiornate. Segui le istruzioni dettagliate per gestire al meglio i processi.</p>
          <div class="divisorio"></div> <!-- Divisorio sotto la descrizione -->
        </div>

        <!-- Ciclo su ogni argomento -->
        <div v-for="(topic, topicIndex) in topics" :key="topicIndex" class="topic-container">
          <h2>{{ topic.title }}</h2>

          <!-- Ciclo sugli accordion di ogni argomento -->
          <div v-for="(accordion, index) in topic.accordions" :key="index">
            <h3 @click="toggleAccordion(topicIndex, index)" class="accordion-title">
              {{ accordion.title }}
            </h3>
            <div v-bind:class="{ 'accordion-content': true, 'open': isAccordionOpen(topicIndex, index) }">
              <!-- Qui usiamo v-html per interpretare il contenuto HTML -->
              <div v-if="isAccordionOpen(topicIndex, index)" class="accordion-text" v-html="accordion.content"></div>
            </div>
          </div>
        </div>
<!--
        <button @click="printProcedures" class="print-button">Stampa Procedure</button>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import SidebarComponent from '../SidebarComponent.vue';

export default {
  components: {
    SidebarComponent,
  },
  setup() {
    // Definiamo i dati per gli argomenti e gli accordion
    const topics = ref([


    {
        title: 'Caricare Piani Alimentari in APP',
        accordions: [
          {
            title: '18/11/2024',
            content: `Da oggi è disponibile una nuova funzionalità per il caricamento dei piani alimentari. Questa procedura semplifica il processo, migliorando l’esperienza utente e riducendo i problemi legati alla visualizzazione dei link.
            
<strong>Passaggi per caricare un piano alimentare</strong>

1.Accedi alla sezione dedicata
  - Vai alla pagina relativa al caricamento dei piani alimentari.

2. Trascina il file PDF
  - Troverai un riquadro dedicato per il caricamento dei documenti.
  - Trascina il file PDF della dieta direttamente all’interno del riquadro.
  - In alternativa, clicca sul riquadro per selezionare manualmente il file dal tuo dispositivo.

3. Compila i campi richiesti
  - KCAL: Inserisci le kcal totali previste dal piano alimentare.
  - Rotazione: Seleziona dal menù a tendina il codice di rotazione corrispondente.
    • I numeri a sinistra dello slash (/) indicano i giorni di carico carbo.
    • I numeri a destra dello slash (/) indicano i giorni di scarico, scarico parziale o dimezzamenti.

<strong>Nota</strong>: Consulta la legenda disponibile sotto il menù per eventuali dubbi sulla codifica delle rotazioni.

4.Salva il piano alimentare
  - Premi il pulsante "Salva" per completare il caricamento.
  
  <a href="https://download-video.akamaized.net/v3-1/playback/2a95fc69-b3ed-421c-b13b-35deb1458682/fe57ee29?__token__=st=1731920768~exp=1731935168~acl=%2Fv3-1%2Fplayback%2F2a95fc69-b3ed-421c-b13b-35deb1458682%2Ffe57ee29%2A~hmac=b0bd4060d560282761a5c657c60897574d652de0382e88414000e0511b90d5c1&r=dXMtd2VzdDE%3D" target="_blank">Guarda il Video tutorial</a>
  <a href="https://www.fusco.fit/wp-content/uploads/2024/11/rotazioni.png" target="_blank">Guarda la legenda delle rotazioni</a>
  `,
},
],
},


    {
  title: 'Procedura Senza Pensieri',
  accordions: [
    {
      title: '01/09/2024',
      content: `Il servizio "Senza Pensieri" può essere acquistato entro 10 giorni dalla data di acquisto di qualsiasi servizio per offrire maggiore flessibilità in caso di imprevisti. Questo servizio permette di accedere alle opzioni di rimborso e sospensione come descritto nei nostri termini e condizioni.

<strong>Link per l'acquisto entro i 10 giorni:</strong>
- FC4 - <a href="https://www.fusco.fit/?add-to-cart=58444" target="_blank">https://www.fusco.fit/?add-to-cart=58444</a>
- FC10 - <a href="https://www.fusco.fit/?add-to-cart=60413" target="_blank">https://www.fusco.fit/?add-to-cart=60413</a>

Segui questi passaggi per aggiungere il servizio "Senza Pensieri" al tuo percorso:
1. Clicca sul link appropriato sopra entro 10 giorni dall'acquisto del tuo servizio.
2. Conferma il tuo acquisto cosi da sincronizzarlo con il servizio già attivo.
3. Approfitta della flessibilità offerta per gestire al meglio eventuali imprevisti durante il tuo percorso.

<strong>TERMINI E CONDIZIONI</strong>
5.2.4 Sospensione e Rimborso dei Servizi (Aggiornamento al 1° agosto 2024)
La sospensione o il rimborso dei servizi acquistati non sono consentiti a meno che non si sia optato per l’acquisto del servizio accessorio “Senza Pensieri”, introdotto il 1° agosto 2024. In caso di acquisto di tale servizio, la sospensione o il rimborso possono essere autorizzati esclusivamente dall’amministrazione di Fusco, che valuterà le certificazioni o i referti medici presentati. I criteri e le condizioni specifiche includono:

• <strong>Problemi di salute</strong>: Rimborso o sospensione del servizio sono possibili previa presentazione di un certificato medico e relativa approvazione da parte dell’amministrazione.
• <strong>Problemi personali certificabili</strong>: La sospensione o il rimborso sono garantiti solo a seguito di verifica documentale e approvazione dell’amministrazione.
• <strong>Problemi personali valutati dalla direzione</strong>: A discrezione della direzione aziendale, può essere concesso un rimborso o una sospensione.

<strong>Importante</strong>: In assenza del servizio “Senza Pensieri”, non sarà possibile ottenere rimborsi o sospensioni sotto alcuna circostanza. Qualsiasi rimborso autorizzato sarà erogato esclusivamente tramite nota di credito, utilizzabile entro 24 mesi dall’emissione per l’acquisto di altri servizi offerti da Fusco.

<strong>Eccezioni</strong>: La gravidanza sarà considerata un caso eccezionale per sospensioni, soggette alla valutazione della Direzione con certificato

<strong>Informazioni</strong>: Sarà comunicato alle allieve che senza questo pacchetto non sarà possibile accedere a rimborsi e sospensioni, con messaggio alla prima consegna, dopo l’informativa a voce

<strong>Informazioni Aggiuntive sui Pacchetti di FITNESS COACHING:</strong>

<strong>Non Rimborsabili:</strong> I pacchetti di fitness coaching a medio e lungo termine non sono rimborsabili, e le sospensioni sono limitate a casi eccezionali, conformemente alla nostra policy di vendita.</li>

<strong>Attivazione:</strong> Ad agosto, il prodotto era disponibile a 69 euro anche per programmi in corso. Da settembre, i prezzi sono 69 e 119 euro, e può essere attivato solo insieme all'acquisto del pacchetto o entro 10 giorni dalla consegna del primo programma.

<strong>Scadenza:</strong> La validità del prodotto segue quella del pacchetto a cui è associato.

<strong>Richieste Consentite:</strong> È possibile richiedere sospensioni per problemi di salute (con certificazione), problemi personali certificabili e altre problematiche, che saranno approvate a discrezione della Direzione. La gravidanza è considerata un caso eccezionale per sospensioni, soggetta alla valutazione della Direzione con certificato.

<strong><h3>Procedura per Richieste di Note di Credito</h3></strong>

<strong>1. Acquisti Prima del 5 Agosto</strong>

<strong>Informativa:</strong> I clienti sono stati avvisati del servizio “senza pensieri” e hanno avuto tempo fino al 31 agosto per acquistarlo.
<strong>Decisione:</strong> Non si forniscono note di credito né si sospendono acquisti.

<strong>Risposte a Reclami:</strong>
- Se il cliente afferma di non essere stato informato o se ci sono presunti errori, non accogliere la richiesta.
- Se insistono, fornire l'email: direzione@fusco.fit per ulteriori comunicazioni.

<strong>2. Acquisti Dopo il 5 Agosto</strong>

<strong>Politica Generale:</strong> Non si sospendono o forniscono note di credito senza il servizio “senza pensieri” attivo.
<strong>Se il servizio è attivo:</strong>
• Se la sede accetta le certificazioni fornite, emettere:
  - Nota di credito da utilizzare entro 24 mesi, oppure
  - Sospensione del percorso.`

    }
  ]
},


      {
        title: 'Acquisto percorso in studio e spedizione da Magazzino',
        accordions: [
          {
            title: '24/09/2024',
            content: `Vi allego la procedura da fare per poter vendere i percorsi di integrazione, <strong>CON PAGAMENTO DIRETTO IN STUDIO POS o CONTANTI e SPEDIZIONE A DOMICILIO</strong>.

Alcuni di voi lo hanno già usato nei coaching day, per gli altri riassumo brevemente poi se avete dubbi chiamatemi.

- Illustrate il percorso in appuntamento (vi allego uno screen riassuntivo che ho fatto da sito per i coaching day che vi aiuta a spiegare il percorso, avendo a vista l’immagine dei prodotti che lo compongono).
- Effettuate il pagamento della corretta cifra con pos o contanti.
- Chiedete conferma all’Allieva che l’indirizzo di spedizione sia quello che vedete a gestionale o vi fate dare l’indirizzo a cui vuole riceverli.
- A chiusura dell’appuntamento andate sul link a seguire:

<a href="https://www.fusco.fit/listino-prezzi/" target="_blank">https://www.fusco.fit/listino-prezzi/</a>

1) Scegliete il percorso.
2) A carrello confermate di andare al pagamento.
3) Fate alcuni “refresh” sino a che visualizzate il “pagamento in studio”. (se non lo vedete subito).
4) Inserite tutti i dati.
5) Confermate.
6) Attendete alcuni minuti e l’ordine arriverà a gestionale.
7) Il sito invierà l’ordine al magazzino.
8) Inviate una mail ad assistenza per modificare la tipologia di pagamento a gestionale, che entrerà come “cod”, nel pagamento pos o contanti (quindi ricordate di inserire dati cliente e metodo di pagamento da inserire).

A SEGUIRE UN BREVE TUTORIAL SULL’UTILIZZO:

<a href="https://player.vimeo.com/video/1010260018" target="_blank">https://player.vimeo.com/video/1010260018</a>

Questa procedura non scaricherà prodotti dal vostro magazzino, ma procederà esattamente come se l’ordine fosse fatto a sito.

Fatemi sapere se avete dubbi.

POTETE TRANQUILLAMENTE GESTIRLO DOPO AVER CHIUSO L’APPUNTAMENTO O A CHIUSURA DI UN CDAY, BASTA AVERE TUTTI I DATI DA INSERIRE.`,
          },
        ],
      },



      {
        title: 'Oscuramento Programmi Allenamento',
        accordions: [
        {
  title: '21/08/2024',
  content: `Andremo ad oscurare ( <strong>NON CANCELLARE</strong> ) <strong>TUTTI</strong> i programmi <strong>SCADUTI</strong> su My Wellness dal 01/01/2024 fino al 31/07/2024, caricando un programma con solo runner per <strong>TUTTI I TIPI DI PACCHETTI ACQUISTATI</strong> (FC1 FC4 FC10).

- Per tutti i programmi scaduti (trascorsi i 30 giorni), daremo un <strong>MARGINE DI 20 GIORNI</strong> prima di procedere all'oscurazione (così da non incombere in problematiche se ci sono allieve che iniziano con 3/4 giorni di ritardo).

Per tutte le allieve che chiederanno il PDF dell'allenamento, l'indicazione ad oggi da dare è che <strong>L'APPLICAZIONE NON CI PERMETTE PIÙ DI SCARICARLI</strong>, quindi siamo impossibilitati nella richiesta.

Se capiterà che ci saranno lamentele sull'oscuramento dei programmi (da allievi che continuavano ad utilizzarlo dopo la scadenza), la comunicazione da dare è che <strong>IL PROGRAMMA ACQUISTATO HA VALIDITÀ 30 GIORNI</strong>, e per ottenere risultato va cambiato ogni 30 giorni (soprattutto per i pacchetti da 4 programmi e 10 programmi).

<strong>22/08/2024</strong> - Vi scrivo per darvi una direttiva per tutte le problematiche che vi arrivano sia sull'oscuramento dei programmi di allenamento, sia sui rimborsi e sospensioni da quando abbiamo attivato il "Senza Pensieri". Il canale da utilizzare è sempre <a href="mailto:DIREZIONE@FUSCO.FIT">DIREZIONE@FUSCO.FIT</a>.

Ovviamente, se riuscite a gestire e chiudere queste situazioni, non c’è bisogno di mandare una mail o girare il problema in sede. Qualora la comunicazione che vi abbiamo fornito di dare per entrambe le situazioni sopra indicate (nella mail del 9 agosto avete tutto scritto) non abbia un riscontro positivo da parte dell’allieva, avvisateci preventivamente inviandoci una mail dove ci spiegate la situazione.

Successivamente, potete indicare all’allieva di scrivere alla mail DIREZIONE ed esporre il problema, così da lavorarla direttamente dalla sede.

Vi metterò in CCN così da avere anche voi un quadro finale della situazione.`,
}

        ],
      },

      {
        title: 'Fitness Coaching Premium',
        accordions: [
        {
  title: '01/09/2024',
  content: `Nasce per ovviare a tutte le allieve che:
1) hanno problematiche importanti e necessitano di un supporto e/o monitoraggio più frequente.
2) lamentano la necessità di avere un contatto costante con me e le nutrizioniste.
3) richiedono maggiori attenzioni, maggior assistenza, maggior disponibilità.

È un servizio ad un <strong>prezzo importante</strong> e quindi va spiegato correttamente nei minimi dettagli e offerto a coloro che risultano nel target. Lo proporremo sia alle nuove che alle allieve consolidate.

Nel caso specifico delle allieve consolidate, c’è un apposito form per fare l'upgrade richiedendo informazioni sulla somma da corrispondere. Useremo come base di calcolo i mesi restanti al percorso originario (no dilazioni, no ritardi, no scuse) applicando la somma su base mensile moltiplicata per i mesi restanti per determinare il credito.

<strong>Esempio:</strong>
Faccio FC12 il primo giugno, passo all'upgrade il primo settembre. HO USUFRUITO DI 3 MESI, quindi 600 euro (costo FC12) diviso 12 fa 50 euro per i nove mesi restanti (non utilizzati), ho un credito di 450 euro da applicare come sconto al servizio Fitness Coaching Premium.

<strong>Mio consiglio:</strong> non entrate nello specifico di questo, fate compilare il form, lasciate a noi poi le delucidazioni.

Sono certo che oltre a fornirci un’ulteriore spinta professionale ci toglierà molte problematiche con allieve difficili da gestire dove fino a ieri non avevamo carte da giocare.

Trovate nella spiegazione anche <strong>TEST MEDICALI</strong>, questo indica una convenzione che abbiamo siglato con un'azienda specializzata in test medici a distanza di diverse tipologie. 

Andremo noi ad indicare quale test occorre per il servizio Premium, oltre a dare possibilità a tutte le allieve di poter fare dei test medici utili per il nostro lavoro. (Nel Premium sono compresi, per le altre sono a pagamento).

Link sito: <a href="https://www.fusco.fit/fitness-coaching-premium/" target="_blank">Fitness Coaching Premium</a>

Link Plus: <a href="https://www.metodofusco.it/media/procedure/plus_premium.png" target="_blank">Dettagli</a>

Link test medicali: <a href="https://www.metodofusco.it/media/procedure/Listino%20Prezzi%20specialisti%202024-1-1.pdf" target="_blank">Test medicali listino pdf</a>

`
}
        ],
      },



      {
        title: 'Porta un\' amica',
        accordions: [
        {
  title: '07/11/2023',
  content: `<strong>Promo attiva dal 7 novembre 2023 sino a nuova comunicazione</strong>.

  <strong>La promo Porta un’amica non può sommarsi (in nessun caso) ad altre promozioni.</strong>

- Acquisto minimo 99 euro per ottenere lo sconto (sia per chi presenta, che per chi è stato presentato).

- Lo sconto è applicabile per chi presenta nuovi utenti e/o utenti <strong>NON ATTIVI</strong> nel 2023 (quindi ex clienti degli anni precedenti) che effettuano un acquisto di minimo 99 euro.

- Sconto 50 euro per chi presenta e per chi è presentato (all’acquisto del servizio).

- Valido su tutti i servizi (ad esclusione di solo dieta o solo allenamento).

- Può essere cumulativo.

- Per chi ha pacchetti 10 programmi, 4 programmi o pacchetti PT, potrà usufruirne fino a 1 mese oltre la scadenza del servizio attivo.  
  (Esempio: un annuale in corso presenta un'amica il 15/11/23, il suo annuale scade il 5/4/24, potrà usufruire del suo sconto dal 15/11/23 al 5/5/24).

- Al momento non è attivo sui prodotti.

- Per chi avesse appena attivato un 10 programmi e non volesse attendere la scadenza per usufruirne, valutiamo insieme che altre possibilità possiamo dare alla cliente, sempre avendo già proposto l’acquisto del servizio PT.

Ovviamente, specialmente per sconti cumulativi, è consigliabile portare la cliente all’acquisto di un servizio maggiore (esempio: 100 euro di sconto, acquisto di 4 programmi /10 programmi / pacchetto PT).

<strong>A GESTIONALE:</strong> 

Nella nota dell’ordine inseriamo sempre: <strong>AMICA - COGNOME E NOME DI CHI PRESENTA - COGNOME E NOME DI CHI È STATO PRESENTATO</strong> (in modo che la parola AMICA sia una chiave di ricerca per dati esportati).

Tenete traccia in lista unica o in un foglio dedicato, magari come secondo foglio in lista unica, di queste promo applicate, anche perché potrebbero riscattare lo sconto dopo mesi e sarà utile sapere quante persone/mese lo utilizzeranno.`,
}

        ],
      },

      {
        title: 'Come acquistare la Gift Card online?',
        accordions: [
        {
  title: '01/01/2024',
  content: `Dalla pagina dedicata del sito: <a href="https://www.fusco.fit/prodotto/gift-card/" target="_blank">https://www.fusco.fit/prodotto/gift-card/</a>

- Selezionare la data di consegna della mail regalo.
- Selezionare un importo tra quelli proposti (59, 99, 150, 200 EUR) o inserire un importo libero.
- Inserire nome, cognome, indirizzo mail del destinatario.
- Inserire proprio nome.
- Inserire un messaggio personalizzato e <strong>AGGIUNGERE AL CARRELLO</strong>.
- A seguire potete anche rateizzare con Alma.

Durante la successiva fase d’acquisto si inseriranno, come da prassi, i dati di fatturazione per procedere poi al pagamento con le solite modalità di acquisto sul sito. Chi acquista la gift card riceverà automaticamente: conferma d’acquisto e copia del buono regalo, in due mail distinte. Il buono regalo verrà recapitato via mail al destinatario nel giorno indicato, con indicazione dell’importo e del codice relativo.

<strong>Come utilizzare la Gift Card online:</strong>

Dal momento della ricezione del buono, il destinatario potrà procedere ad acquisti sul sito inserendo nel carrello il codice riportato sul buono stesso: l’importo disponibile verrà scalato automaticamente dal totale dell’ordine.

Non è necessario usare tutto il buono in un unico acquisto, sarà possibile inserire il codice più volte, fino ad esaurimento del credito.

<strong>PER GLI ACQUISTI DI GIFT E L'UTILIZZO DELLA STESSA IN STUDIO, GUIDATELI NELL’OPERAZIONE</strong>.`,
}


        ],
      },



    ]);

    const openAccordion = ref({ topicIndex: null, accordionIndex: null });

    // Funzione per aprire/chiudere un accordion
    const toggleAccordion = (topicIndex, accordionIndex) => {
      if (
        openAccordion.value.topicIndex === topicIndex &&
        openAccordion.value.accordionIndex === accordionIndex
      ) {
        openAccordion.value = { topicIndex: null, accordionIndex: null };
      } else {
        openAccordion.value = { topicIndex, accordionIndex };
      }
    };

    // Verifica se un accordion è aperto
    const isAccordionOpen = (topicIndex, accordionIndex) => {
      return (
        openAccordion.value.topicIndex === topicIndex &&
        openAccordion.value.accordionIndex === accordionIndex
      );
    };

    const printProcedures = () => {
      window.print();
    };

    return {
      topics,
      toggleAccordion,
      isAccordionOpen,
      printProcedures,
    };
  },
};
</script>

<style scoped>
.procedure-container {
  margin-top: 20px;
}

.accordion-title {
  cursor: pointer;
  background-color: #4CAF50;
  color: white;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.accordion-content {
  display: none;
  background-color: #f1f1f1;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.accordion-content.open {
  display: block;
}

.print-button {
  margin-top: 20px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.print-button:hover {
  background-color: #0056b3;
}

.accordion-text {
  white-space: pre-wrap; /* Per mantenere le interruzioni di linea */
}

h2 {
  font-size: 21px;
  margin: 40px 0 20px;
  color: #1f1f1f;
  text-align: center;
}

/* Introduzione - Design minimale e pulito */
.introduzione {
  margin-bottom: 30px;
  padding: 10px;
}

.introduzione h1 {
  font-size: 28px;
  color: #2c3e50;
}

.introduzione p {
  font-size: 18px;
  color: #34495e;
  margin-top: 10px;
}

/* Divisorio sotto la descrizione */
.divisorio {
  border-bottom: 2px solid #ddd;
  margin-top: 20px;
}

/* Usa :deep(...) per forzare lo stile del link */
:deep(a) {
  color: rgb(193, 0, 0) !important; /* Colore del link */
  text-decoration: underline !important; /* Sottolineatura del link */
  font-weight: 700 !important;
}
</style>
